<template>
  <section>
    <div class="row col-12 q-gutter-sm items-center q-mt-md">
      <div class="col-2">
        <ListaUnidadesSelect />
      </div>
      <div class="col-3">
        <q-file label="Selecione o Template" outlined dense v-model="file">
          <template v-slot:prepend>
            <q-icon name="attach_file" />
          </template>
        </q-file>
      </div>
      <div class="col-2">
        <q-btn
          color="positive"
          no-caps
          icon="file_upload"
          label="Enviar Template"
          :loading="isLoading"
          :disable="isLoading"
          @click="enviarTemplate"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { salvarCatalogoUuid } from "../composables/salvarCatalogoUuid";

import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";

export default {
  components: { ListaUnidadesSelect },
  props: {
    mapeamento: {
      type: String,
      required: true,
    },
    link: {
      type: String,
    },
    title: {
      type: String,
    },
  },
  setup(props) {
    const quasar = useQuasar();
    const store = useStore();
    const file = ref(null);
    const isLoading = ref(false);
    const catalogoUuid = salvarCatalogoUuid();

    const getTipoPlanilha = (mapeamento) => {
      const mapeamentos = {
        criacao_itens_catalogo: "catalogo_item_criacao",
        criacao_ativos: "ativo_criacao",
        exclusao_ativos: "ativo_exclusao",
        associacao_acessorio_item_catalogo:
          "catalogo_item_acessorio_associacao",
        associacao_atributos_item_catalogo: "catalogo_item_atributo_associacao",
        associacao_checklists_item_catalogo:
          "catalogo_item_checklist_associacao",
      };
      return mapeamentos[mapeamento];
    };

    const enviarTemplate = async () => {
      if (file.value == null || file.value.name.indexOf("xlsx") == -1) {
        quasar.notify({
          message: "O tipo do arquivo não é aceito, ou o campo esta vazio",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      const planilhaTipo = getTipoPlanilha(props.mapeamento);

      if (!planilhaTipo) {
        quasar.notify({
          message: "Tipo de planilha não reconhecido",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      if (!catalogoUuid.catalogoUuid.value) {
        quasar.notify({
          message: "Nenhum catálogo encontrado para esta unidade",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      isLoading.value = true;

      try {
        const tiposResponse = await store.dispatch(
          "ferramentaria/listarTiposPlanilha"
        );
        const tiposAceitos = tiposResponse.data.resultado.dados;

        if (!tiposAceitos.includes(planilhaTipo)) {
          throw new Error(
            `Tipo de planilha '${planilhaTipo}' não é aceito pelo sistema`
          );
        }

        const urlUploadResponse = await store.dispatch(
          "ferramentaria/buscarUrlUploadPlanilha",
          {
            planilhaTipo,
            nomeArquivo: file.value.name,
          }
        );

        const formAttributes =
          urlUploadResponse.data.resultado.dados.formAttributes;
        const formInputs = urlUploadResponse.data.resultado.dados.formInputs;
        const formData = new FormData();

        for (let input in formInputs) {
          formData.append(input, formInputs[input]);
        }
        formData.append("file", file.value);

        const request = new XMLHttpRequest();
        request.open(formAttributes.method, formAttributes.action);

        await new Promise((resolve, reject) => {
          request.onload = () => {
            if (request.status === 200 || request.status === 204) {
              resolve();
            } else {
              reject(new Error(`Upload falhou: ${request.status}`));
            }
          };
          request.onerror = () => reject(new Error("Erro no upload"));
          request.send(formData);
        });

        const urlArquivo = `${formAttributes.action}/${formInputs.key}`;

        const usuarioLogado = store.state.autenticacao.usuarioLogado;
        const unidadeData = store.state.org.unidadeData;

        const dadosEnvio = {
          url: urlArquivo,
          catalogoUuid: catalogoUuid.catalogoUuid.value,
          usuarioId: usuarioLogado.id,
          usuarioNome: usuarioLogado.nome,
          unidadeId: unidadeData.id,
          background: true,
        };

        switch (props.mapeamento) {
          case "criacao_itens_catalogo":
            await store.dispatch(
              "ferramentaria/uploadItemCatalogoPlanilha",
              dadosEnvio
            );
            break;
          case "criacao_ativos":
            await store.dispatch(
              "ferramentaria/uploadAtivosPlanilha",
              dadosEnvio
            );
            break;
          case "exclusao_ativos":
            await store.dispatch(
              "ferramentaria/deleteAtivosPlanilha",
              dadosEnvio
            );
            break;
          case "associacao_acessorio_item_catalogo":
            await store.dispatch(
              "ferramentaria/uploadAcessorioItemCatalogoPlanilha",
              dadosEnvio
            );
            break;
          case "associacao_atributos_item_catalogo":
            await store.dispatch(
              "ferramentaria/uploadAtributoItemCatalogoPlanilha",
              dadosEnvio
            );
            break;
          case "associacao_checklists_item_catalogo":
            await store.dispatch(
              "ferramentaria/uploadChecklistItemCatalogoPlanilha",
              dadosEnvio
            );
            break;
          default:
            throw new Error(`Mapeamento não reconhecido: ${props.mapeamento}`);
        }

        quasar.notify({
          message: "Template enviado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.error("Erro detalhado:", error);

        let errorMessage = "Erro ao enviar template";

        if (error.response?.data?.erro) {
          errorMessage =
            error.response.data.erro.mensagem ||
            error.response.data.erro.detalhes?.catalogoUuid?.[0] ||
            errorMessage;
        } else if (error.response?.data) {
          errorMessage =
            error.response.data.result?.error ||
            error.response.data.error ||
            error.response.data.message ||
            error.response.data.result ||
            error.response.data.erros?.mensagem ||
            errorMessage;
        } else if (error.message) {
          errorMessage = error.message;
        }

        quasar.notify({
          message: errorMessage,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } finally {
        isLoading.value = false;
        file.value = null;
      }
    };

    return {
      enviarTemplate,
      file,
      isLoading,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
